<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { PlayIcon, RectangleHorizontalIcon } from "lucide-vue-next";
import { useRichTextContext } from "../context";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

const { toggleUpdateEmbedOpen } = useRichTextContext();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ onlyIfEmpty: true }))
    .run();

  toggleUpdateEmbedOpen(true);
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    @pointerdown.prevent
    @click="run"
    @keydown.enter="run"
  >
    <template #icon>
      <div class="flex size-4 items-center justify-center pl-px">
        <RectangleHorizontalIcon class="absolute size-5" :stroke-width="1.4" aria-hidden="true" />
        <PlayIcon class="size-1.5 fill-current" aria-hidden="true" />
      </div>
    </template>
    Embed
  </SuggestionListItem>
</template>
